const onesecond = 1000;
const oneminute = 60 * onesecond;
const onehour = 60 * oneminute;

export default {
  SECOND: onesecond,
  MINUTE: oneminute,
  HOUR: onehour,
};
